import React from 'react';
import { Box, Paragraph, Text } from 'bumbag';
type Props = {
  amountBenefit: string;
};

const LocationPermissionsRequested = ({ amountBenefit }: Props) => (
  <Box>
    <Paragraph>
      We need your location in order to process your health fund benefit
      {amountBenefit ? (
        <Text>
          {' '}
          of <Text fontWeight="bold">{amountBenefit}</Text>
        </Text>
      ) : (
        ''
      )}
      .
    </Paragraph>
    <Paragraph>
      If you do not share your location, we will be unable to process this private health insurance claim and payment,
      and your payment will remain outstanding.
    </Paragraph>
  </Box>
);

export default LocationPermissionsRequested;
